import React from "react";
import ModifiedActivitiesList from "./Rules&ConfigList";
import { FscContent } from "./FscContent";
import { Icon, Typography } from "antd";
import moment from "moment";
import { RateSheetContent } from "./RateSheetContent";
import { AllConfigKeys } from "../../common/AllConfigKeys";
import AccModifiedList from "../AllAccActivities/Rules&ConfigList";
import { MainAccessorialDetails } from "../AllAccActivities/MainAccessorialDetails";
import { ZipCodeDetails } from "../AllAccActivities/ZipCodeDetails";
import { ZoneByDistanceDetails } from "../AllAccActivities/ZoneByDistanceDetails";
import { ellipseText, isEmpty } from "../../common/Common";
import { ZipCodeCitiesDetails } from "../AllAccActivities/ZipCode&CitiesDetails";
import { DriverRateContent } from "../AllAccActivities/DriverRateContent";
import { OrgDriverRatesContent } from "../AllAccActivities/OrgDriverRatesContent";
import { DriverDeductions } from "../AllAccActivities/DriverDeductions";
import { IndividualDriverRates } from "../AllAccActivities/IndividualDriverRates";
import { Adjustments } from "../AllAccActivities/Adjustments";
import { AccCloneActivity } from "../AllAccActivities/AccCloneActivity";
const { Text } = Typography;


export const OrgTabKeys = [
    "general_setting",
    "org_rules",
    "fuel_surcharge",
    "rate_sheet",
    "accessorials",
    "org_accessorials",
    "driver_rate",
    "driver_rate_sheet",
    "driver_deductions",
    "individual_driver_rates",
    "adjustments",
    "invoice_pod_mapping",
  ];

  export const AccTabKeys = [
   "accessorials",
   "adjustments",
   "accounts",
   "acc_general_setting",
   "rule",
   "settings",
   "level_of_services",
   "billing_zones",
   "delivery_zipcodes",
   "dim_configuration",
   "fuel_surcharge",
   "rate_sheet",
    "driver_rate",
  ]

  export const getConfigKey = (key) => {
    return !isEmpty(key) ? AllConfigKeys[key] ?? key.replace(/_/g, " ") : "";
  }

  export const checkIncomingDataType = (data) => {
    switch (true) {
      case data === null || data === undefined || data === "" || data === "N/A" || data === "n/a":
        return <Text type="secondary">N/A</Text>;
  
      case typeof data === "string": {
        if (data.includes("000Z")) {
          return new Date(data).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        }
        const lowerCased = data.toLowerCase();
        if (lowerCased === "true" || lowerCased === "false") {
          return <Text>{lowerCased === "true" ? "true" : "false"}</Text>;
        }
        return <Text>{(data).replace(/_/g, " ")}</Text>;
      }
  
      case typeof data === "boolean":
        return <Text>{data ? "true" : "false"}</Text>;
  
      case typeof data === "number":
        if (isNaN(data)) {
          return <Text type="warning">Not a Number</Text>;
        }
        return <Text>{data}</Text>;
  
      case typeof data === "object": {
        try {
          return <Text>{JSON.stringify(data)}</Text>;
        } catch (error) {
          return <Text type="danger">Unsupported Object</Text>;
        }
      }
  
      case typeof data === "function":
      case typeof data === "symbol":
        return <Text type="danger">Unsupported Data</Text>;
  
      default:
        return <Text type="warning">Unknown Type</Text>;
    }
  };


  export const renderColumn = (col, type) => {
      const originalRender = col.render;
    return {
      ...col,
      render: (text, record, index) => {
         const value = originalRender
        ? originalRender(text, record, index)
        : record[col.dataIndex];
  
        if (_.isNil(value) || value === "") {
          return "N/A";
        }
  
        switch (col.key) {
          case "surcharge_type":
            return type === "REMOVED" ? <Text delete>{_.startCase(value)}</Text> : _.startCase(value);
  
          case "is_default":
            return value ? (
              <Icon type="check-circle" style={{ color: "green" }} />
            ) : (
              <Icon type="close-circle" style={{ color: "red" }} />
            );
  
          case "effective_from_date":
          case "effective_to_date":
            return type === "REMOVED" ? (
              <Text delete>{moment(value).utc().format("DD-MM-YYYY")}</Text>
            ) : (
              moment(value).utc().format("DD-MM-YYYY")
            );
  
          case "surcharge_value":
            return type === "REMOVED" ? <Text delete>{value}</Text> : value;
          
          case "zip_codes":
            return type === "REMOVED" ? (
              <Text delete>
                {value
                  .split(",")
                  .map((zip) => zip.trim())
                  .join(", ")}
              </Text>
            ) : (
              value
                .split(",")
                .map((zip) => zip.trim())
                .join(", ")
            );
  
          default:
            return type === "REMOVED" ? <Text delete>{value}</Text> : value;
        }
      },
    };
  };
  
  const highlightStyle = {
    backgroundColor: "yellow",
  };
  

export const getHighlightClass = (oldValue, newValue, screenFrom = "", isNewRow = false) => {
  // Normalize values for comparison (handle string vs number)
  const normalizedOld = oldValue === undefined ? undefined : String(oldValue).trim();
  const normalizedNew = newValue === undefined ? undefined : String(newValue).trim();
  
  if (
    new Set(["Chargeable Accessorial", "Included Accessorial", "driverRatesZones"]).has(screenFrom)
  ) {
    return null;
  }

  // Highlight entire row if it's a new row
  if (isNewRow) {
    return highlightStyle;
  }

  // Highlight if old value is undefined (field didn't exist before)
  if (normalizedOld === undefined && normalizedNew !== undefined) {
    return highlightStyle;
  }

  // Highlight if values changed
  if (normalizedOld !== undefined && normalizedOld !== normalizedNew) {
    return highlightStyle;
  }

  return null;
};


export const getColumnsWithHighlight = (table, oldValues = [], newValues = [], screenFrom = "") => {
  if (_.isEmpty(table)) return [];
  
  return table.map((column) => ({
    ...column,
    render: (text, record, index) => {
      // Check if this row exists in oldValues
      const oldRecord = oldValues[index];
      const newRecord = newValues[index];
      
      // If oldRecord is undefined but newRecord exists, it's a new row
      const isNewRow = oldRecord === undefined && newRecord !== undefined;
      
      // Extract the specific field value from the record object
      const oldValue = oldRecord ? oldRecord[column.dataIndex] : undefined;
      const newValue = newRecord ? newRecord[column.dataIndex] : undefined;
      
      const cellStyle = getHighlightClass(oldValue, newValue, screenFrom, isNewRow);

      return (
        <div style={cellStyle}>
          {column.render ? column.render(text) : text}
        </div>
      );
    },
  }));
};
  
  export const expandIconRendering = (props) => {
    if (!_.isEmpty(props.record.contract_config)) {
      return (
        <span
          className={`ant-table-row-expand-icon ${
            props.expanded ? "ant-table-row-expanded" : "ant-table-row-collapsed"
          }`}
          onClick={(e) => props.onExpand(props.record, e)}
        />
      );
    }
    return null;
  };
  
  export const getRowClassName = (record, oldConfig, newConfig, isOldTable) => {
    if (!oldConfig && isOldTable) {
      return ''; // No config to compare, default style
    }
  
    if(!oldConfig && !isOldTable) {
      return '';
    }
     const configToCompare = isOldTable ? oldConfig : newConfig;
      if(!configToCompare){
        return '';
      }
  
    if (isOldTable) {
        const isRemoved = !newConfig?.some(newRow =>
            _.isEqual(newRow, record)
        );
          return isRemoved ? 'row-removed' : '';
    } else {
      const isNew = !oldConfig?.some(oldRow =>
            _.isEqual(oldRow, record)
        );
      return isNew ? 'row-added' : '';
    }
  };

  export const getRowClassNameForAcc = (record, oldConfig = [], newConfig = [], isOldTable) => {
    if (!Array.isArray(oldConfig) || !Array.isArray(newConfig)) {
      return '';
    }
    // Extract keys for comparison (assuming "code" is unique per row)
    const oldKeys = oldConfig.map(row => row.code);
    const newKeys = newConfig.map(row => row.code);
  
    if (isOldTable) {
      // Check if the row exists in old data but NOT in new data (i.e., removed row)
      return !newKeys.includes(record.code) ? 'row-removed' : '';
    } else {
      // Check if the row exists in new data but NOT in old data (i.e., added row)
      return !oldKeys.includes(record.code) ? 'row-added' : '';
    }
  };
  


  export const groupDifferencesByAction = (data) => {
    const { action, difference } = data;
    return difference.reduce((acc, diff) => {
        switch(action){
            case "CREATE":
                acc.ADDED.push(diff);
                break;
            case "UPDATE":
                acc.MODIFIED.push(diff);
                break;
            case "DELETE":
                acc.REMOVED.push(diff);
                break;
            default:
                console.warn(`Unknown action: ${action}`);
                break;
        }
        return acc;
    }, { ADDED: [], REMOVED: [], MODIFIED: [] });
};

export const baseTableColumns = [
  {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (value) => !_.isEmpty(value) ? _.startCase(value) : "N/A",
      width:80
  },
  {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      render: (value) => !_.isEmpty(value) ? _.startCase(value) : "N/A",
      width:90
  },
  {
      title: "Surcharge Type",
      dataIndex: "surcharge_type",
      key: "surcharge_type",
      render: (value) => !_.isEmpty(value) ? _.startCase(value) : "N/A",
      width:90
  },
  {
    title: "Surcharge Adjustment",
    dataIndex: "surcharge_adjustment",
    key: "surcharge_adjustment",
    render: (value) => value ?? "N/A",
    width:80,
    align: "center"
  },
  {
      title: "Region",
      dataIndex: "region",
      key: "region",
      render: (value) => !_.isEmpty(value) ? _.startCase(value) : "N/A",
      width:80
  },
  {
      title : "Frequency",
      dataIndex: "frequency",
      key: "frequency",
        render: (value) => {
          if(_.isEmpty(value)){
            return "N/A"
          }
          return _.startCase(value)
        },
      width:80
  },
  {
      title: "Day/Date",
      dataIndex: "frequency_value",
      key: "frequency_value",
      render: (value) => !_.isEmpty(value) ? _.startCase(value) : "N/A",
      width:80
  },
  {
      title: "Default",
      dataIndex: "is_default",
      key: "is_default",
      render: (value) => value ? <Icon type="check-circle" style={{ color: "green" }} /> : <Icon type="close-circle" style={{ color: "red" }} />,
      width:80
  },
  {
    title: "Additional Charge",
    dataIndex: "additional_charge_range",
    key: "additional_charge_range",
    render: (value) =>  value ?? "N/A",
    width:80,
    align: "center"
  }
];

export const contractConfigColumns = [
  {
    title: "Effective From Date",
    dataIndex: "effective_from_date",
    key: "effective_from_date",
    render: (value) => moment(value).utc().format("DD-MM-YYYY"),
    width: 120
  },
  {
    title: "Effective To Date",
    dataIndex: "effective_to_date",
    key: "effective_to_date",
    render: (value) => moment(value).utc().format("DD-MM-YYYY"),
    width: 120
  },
  {
    title: "Surcharge",
    dataIndex: "surcharge_value",
    key: "surcharge_value",
    render: (value) => value ?? "N/A",
    width: 120
  }
]

export const losRateSheetColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (value) => value ?? "N/A",
    width: 120
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    render: (value) => value ?? "N/A",
    width: 120
  },
  {
    title :"Duration",
    dataIndex: "duration",
    key: "duration",
    render: (value) => value ?? "N/A",
    width: 120
  },
  {
    title: "Start Date",
    dataIndex: "effective_start_date",
    key: "effective_from_date",
    render: (value) => moment(value).utc().format("DD-MM-YYYY"),
    width: 120
  },
  {
    title: "End Date",
    dataIndex: "effective_end_date",
    key: "effective_to_date",
    render: (value) => moment(value).utc().format("DD-MM-YYYY"),
    width: 120
  },
  {
    title: "Billing Zone",
    dataIndex: "los_zone_ids",
    key: "los_zone_ids",
    render: (value) => value ?? "N/A",
    width: 120
  }
];

export const adjustmentsColumns = [
  {
    title: "Base Rate",
    dataIndex: "Base Rate",
    key: "Base Rate",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text>,
    width: 100
  },
  {
    title: "Beyond Areas",
    dataIndex: "Beyond Areas",
    key: "Beyond Areas",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text> ,
    width: 100
  },
  {
    title: "Driver Rate",
    dataIndex: "Driver Rate",
    key: "Driver Rate",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text>,
    width: 100
  },
  {
    title: "Extra Mile",
    dataIndex: "Extra Mile",
    key: "Extra Mile",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text>,
    width: 100
  },
  {
    title: "Fuel Surcharge",
    dataIndex: "Fuel Surcharge",
    key: "Fuel Surcharge",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text>,
    width: 100
  },
  {
    title: "Second Machine Price",
    dataIndex: "Second Machine Price",
    key: "Second Machine Price",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text>,
    width: 100
  },
  {
    title: "Special Days",
    dataIndex: "Special Days",
    key: "Special Days",
    render: (value) => <Text ellipsis>{ellipseText((value ?? "N/A"),10, true)}</Text>,
    width: 100
  }
]

export const accessorialColumns = [
  {
    title : "Name",
    dataIndex: "name",
    key: "name",
    render: (value) => value ?? "N/A",
    width: 100
  },
  {
    title : "Code",
    dataIndex : "code",
    key:"code",
    render: (value) => value ?? "N/A",
    width: 100
  },
  {
    title: "GL-Number",
    dataIndex: "gl_number",
    key: "gl_number",
    render: (value) => value ?? "N/A",
    width: 100
  }, 
  {
    title : "Accessible To",
    dataIndex: "accessible_to",
    key:"accessible_to",
    render: (value) => value ?? "N/A",
    width: 100
  }
]

export const zonesByDistanceColumns = [
  {
    title: "Zone Name",
    dataIndex: "zone_name",
    key: "zone_name",
    render: (value) => value ?? "N/A",
    width: 100
  },
  {
    title: "Min Distance",
    dataIndex: "min_distance",
    key: "min_distance",
    render: (value) => value ?? "N/A",
    width: 100
  },
  {
    title: "Max Distance",
    dataIndex: "max_distance",
    key: "max_distance",
    render: (value) => value ?? "N/A",
    width: 100
  }
]

export const driverRates = [
  {
    title: "Charge Name",
    dataIndex: "charge_name",
    key: "charge_name",
    render: (value) => value ?? "N/A",
    width: 100,
  },
  {
    title: "Rate Type",
    dataIndex: "rate_type",
    key: "rate_type",
    render: (value) => value ?? "N/A",
    width: 100,
  },
  {
    title: "Rate Value",
    dataIndex: "rate_value",
    key: "rate_value",
    render: (value) => checkIncomingDataType(value) ?? "N/A",
    width: 100,
  },
];


const driverRatesZonesColumn = [
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    width: 150,
    render: (value) => value ?? "N/A",
  },
  {
    title: "City Amount ($)",
    dataIndex: "city_amount",
    key: "city_amount",
    render: (value) => value ?? "N/A",
    width: 120,
  },
  {
    title: "Zip Codes",
    dataIndex: "zip_codes",
    key: "zip_codes",
    width: 250,
  },
];

export const driverDeductions = [
  {
    title: "Deduction Name",
    dataIndex: "deduction_name",
    key: "deduction_name",
    width: 100,
    render: (value) => value ?? "N/A",
  },
  {
    title: "Deduction Type",
    dataIndex: "deduction_type",
    key: "deduction_type",
    width: 100,
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
  {
    title: "Default Amount ($)",
    dataIndex: "default_amount",
    key: "default_amount",
    width: 100,
    render: (value) => value ?? "N/A",
  },
  {
    title: "GL Code",
    dataIndex: "GL_code",
    key: "GL_code",
    width: 100,
    render: (value) => value ?? "N/A",
  }
];

export const driverIndividualRates = [
  {
    title: "Rate Name",
    dataIndex: "key",
    key: "key",
    width: 150,
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
  {
    title: "Rate Value",
    dataIndex: "value",
    key: "value",
    width: 100,
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
]

export const orderRefChanges = [
   {
    title: 'HAWB',
    dataIndex: 'hawb',
    key: 'hawb',
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
  {
    title: 'MAWB',
    dataIndex: 'mawb',
    key: 'mawb',
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
  {
    title: 'Reference 1',
    dataIndex: 'reference_1',
    key: 'reference_1',
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
  {
    title: 'Reference 2',
    dataIndex: 'reference_2',
    key: 'reference_2',
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
]
export const fmpSmpColumns = [
  {
    title: "Zone Name",
    dataIndex: "zone_name",
    key: "zone_name",
    width: 150,
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
    {
    title: "Min Charge",
    dataIndex: "min_charge",
    key: "min_charge",
    width: 150,
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  },
];

export const getDriverRatesZonesColumns = (data, screenFrom = "", isOldValue = false) => {
  const cols = [...driverRatesZonesColumn];
  const extractedData = data && Array.isArray(data) && data.length > 0 ? data[0].old_value : data[0].new_value;
  if (extractedData && extractedData.some((row) => Object.prototype.hasOwnProperty.call(row, 'first_pallet_amount'))) {
    const firstPalletCol = {
      title: "First Pallet Amount ($)",
      dataIndex: "first_pallet_amount",
      key: "first_pallet_amount",
      render: (value) => value ?? "N/A",
      width: 100,
    };
    cols.splice(2, 0, firstPalletCol);
  }

      const hasOldValue = data && Array.isArray(data) && data.length > 0 && data[0].old_value;
      const hasNewValue = data && Array.isArray(data) && data.length > 0 && data[0].new_value;
      const hasBothValues = !_.isEmpty(hasOldValue) && !_.isEmpty(hasNewValue);

  // Add highlighting logic for zipcodes screen
  if (screenFrom === "driverRatesZones" && hasBothValues) {
    const zipCodeColumnIndex = cols.findIndex(col => col.key === "zip_codes");
    
    if (zipCodeColumnIndex !== -1) {
      // Check if both old_value and new_value exist in data
      if (hasBothValues) {
        // Create lookup maps for comparison by city
        const oldValuesByCity = {};
        const newValuesByCity = {};
        
        data[0].old_value.forEach(oldVal => {
          if (oldVal.city) {
            oldValuesByCity[oldVal.city.toLowerCase()] = oldVal;
          }
        });
        
        data[0].new_value.forEach(newVal => {
          if (newVal.city) {
            newValuesByCity[newVal.city.toLowerCase()] = newVal;
          }
        });

        cols[zipCodeColumnIndex] = {
          ...cols[zipCodeColumnIndex],
          render: (zipString, record) => {
            if (!zipString) return "N/A";
            
            const currentZips = zipString.split(",").map(zip => zip.trim());
            
            // Find comparison data based on city
            const cityKey = record.city?.toLowerCase();
            let comparisonZipCodes = null;
            
            if (isOldValue && newValuesByCity[cityKey]) {
              comparisonZipCodes = newValuesByCity[cityKey].zip_codes;
            } else if (!isOldValue && oldValuesByCity[cityKey]) {
              comparisonZipCodes = oldValuesByCity[cityKey].zip_codes;
            }
            
            // If comparison data exists, highlight differences
            if (comparisonZipCodes) {
              const comparisonZips = comparisonZipCodes.split(",").map(zip => zip.trim());
              
              return (
                <span>
                  {currentZips.map((zip, index) => {
                    let backgroundColor = 'transparent';
                    
                    if (isOldValue) {
                      // In old values, highlight removed zips in red
                      const isRemoved = !comparisonZips.includes(zip);
                      backgroundColor = isRemoved ? '#ffcdd2' : 'transparent';
                    } else {
                      // In new values, highlight added zips in yellow
                      const isNew = !comparisonZips.includes(zip);
                      backgroundColor = isNew ? '#fff59d' : 'transparent';
                    }
                    
                    return (
                      <React.Fragment key={`${zip}-${index}`}>
                        <span
                          style={{
                            backgroundColor,
                            padding: '2px 4px',
                            borderRadius: '3px',
                          }}
                        >
                          {zip}
                        </span>
                        {index < currentZips.length - 1 && ", "}
                      </React.Fragment>
                    );
                  })}
                </span>
              );
            }
            
            // Default: no highlighting if no comparison data
            return currentZips.join(", ");
          },
        };
      }
    }
  }
  
  return cols;
};

  export const renderDynamicModal = (title, data) => {
    switch (title) {
      case "GENERAL_SETTING":
      case "ORG_RULES":
      case "RULE":
      case "SETTINGS":
      case "DIM_CONFIGURATION":
      case "INVOICE_POD_MAPPING":
        return (
          <ModifiedActivitiesList
            data={data}
            scroll={{ x: "max-content", y: "calc(100vh - 350px)" }}
            pagination={{ position: "none" }}
          />
        );
      case "FUEL_SURCHARGE":
        return <FscContent data={data} />;
      case "RATE_SHEET":
      case "LEVEL_OF_SERVICES":
        return <RateSheetContent data={data} />;
      case "ACC_GENERAL_SETTING":
        return (
          <AccModifiedList
            data={data}
            scroll={{ x: "max-content", y: "calc(100vh - 350px)" }}
            pagination={{ position: "none" }}
          />
        );
      case "ACCESSORIALS":
        return <MainAccessorialDetails data={data} />;
      case "DELIVERY_ZIPCODES":
        return <ZipCodeDetails data={data} />;
      case "BILLING_ZONES":
        switch (_.get(data.difference[0], "zone_type")) {
          case "location":
            return <ZipCodeDetails data={data} incomingTitle="Billing Zones" />;
          case "city-zipcode":
            return (
              <ZipCodeCitiesDetails
                data={data}
                incomingTitle="Billing Zones & Cities"
              />
            );
          default:
            return <ZoneByDistanceDetails data={data} />;
        }
      case "DRIVER_RATE":
        return <DriverRateContent data={data} />;
      case "DRIVER_RATE_SHEET":
        return <OrgDriverRatesContent data={data} />;
      case "DRIVER_DEDUCTIONS":
        return <DriverDeductions data={data} />;
      case "INDIVIDUAL_DRIVER_RATES":
        return <IndividualDriverRates data={data} />;
      case "ADJUSTMENTS":
        return <Adjustments data={data} />  
      case "ACCOUNTS":
        return <AccCloneActivity data={data} />;  
      default:
        return null;
    }
  };
  